import React from "react";
import { colors } from "src/config/colors";
import Typography from "@mui/material/Typography";
import Container from "src/components/common/Layout/Container";
import { getPharmaciesSchema } from "src/models/pharmacies/getPharmacies";
import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandMore } from "@mui/icons-material";
import AccordionDetails from "@mui/material/AccordionDetails";
import DangerouslyHtml from "src/components/common/DangerouslyHtml/DangerouslyHtml";
import Accordion from "@mui/material/Accordion";
import { createUrl } from "src/utils/helpers/url/createUrl";
import paths from "src/router/paths";
import DefaultButton from "src/components/common/Buttons/DefaultButton";
import { useQuery } from "src/utils/hooks/common/useQuery";
import PharmaciesByCityMap from "src/components/common/PharmaciesByCityMap/PharmaciesByCityMap";
import PharmaciesCompaniesTabs from "src/components/common/PharmaciesCompaniesTabs/PharmaciesCompaniesTabs";
import AnotherRegionsLinks from "src/components/common/AnotherRegionsLinks/AnotherRegionsLinks";

interface PharmacyPageProps {
  pageTitle?: string;
  pharmacyData: getPharmaciesSchema;
}

const PharmacyPage: React.FC<PharmacyPageProps> = ({
  pageTitle,
  pharmacyData,
}) => {
  const { city, company } = useQuery(["city", "company"]);

  return (
    <Container isWithPaper paddingBottom={4}>
      <Typography
        paddingY="20px"
        fontSize="30px"
        fontWeight={550}
        color={colors.darkBlue}
        component="h1"
        mb={3}
      >
        {pageTitle}
      </Typography>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography component="h3" fontWeight={500} color="primary">
            {pharmacyData.article_title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DangerouslyHtml innerHtml={pharmacyData?.html_text} />
        </AccordionDetails>
      </Accordion>
      <DefaultButton
        sx={{
          my: 3,
          padding: 1,
          width: "400px",
          maxWidth: { xs: "100%", sm: "80%" },
          height: "40px",
          backgroundColor: colors.darkBlue,
        }}
        href={createUrl([city, paths.APTEKI, company])}
        typographySx={{ color: colors.white }}
        fontSize={{ xs: "11px", lg: "13px" }}
        title={pharmacyData.company_pharmacies_title}
      />
      <PharmaciesByCityMap
        mapTitle={pharmacyData.map_title}
        data={pharmacyData?.map_pharmacies}
      />
      <PharmaciesCompaniesTabs
        pharmaciesList={pharmacyData.companies}
        firstTabTitle={pharmacyData.companies_title}
      />
      <AnotherRegionsLinks another_regions={pharmacyData.another_regions} />
    </Container>
  );
};

export default PharmacyPage;
